import { Form, Formik } from "formik";

interface Iprops {
  initialValues: any;
  onSubmit: any;
  validationSchema: any;
  children: any;
}
const AppForm = ({
  initialValues,
  onSubmit,
  validationSchema,
  children,
}: Iprops) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize={true}
    >
      {(errors) => <Form>{children}</Form>}
    </Formik>
  );
};

export default AppForm;
